/* Kunstpflanzenmarkt: Höhenwechsel auf der Produktseite.
 *
 * Ein Höhenklick aktualisiert ohne Reload: Preis, H1, Galerie-Badge,
 * Versandblock samt Klassenwechsel, Spec-Zeile Versand, Lieferzeit,
 * CTA-Label, Sticky-Leiste, Größenanker und die URL.
 *
 * Alle Versandtexte kommen als data-Attribut aus snippets/kpm-shipping.liquid.
 * Hier steht bewusst KEINE Kopie der Formulierungen und keine Versandzahl.
 *
 * Auch die Beschriftungen der Kaufschaltfläche kommen als data-Attribut aus
 * der Sektion, weil sie im Theme-Editor gepflegt werden. Eine Kopie an dieser
 * Stelle würde den gepflegten Text beim ersten Höhenwechsel überschreiben.
 */

(function () {
  'use strict';

  var root = document.querySelector('[data-kpm-product]');
  if (!root) return;

  var buttons = root.querySelectorAll('[data-kpm-height]');
  if (!buttons.length) return;

  var PARAM = 'hoehe';

  var LABEL_CTA = root.dataset.kpmLabelCta || '';
  var LABEL_AUSVERKAUFT = root.dataset.kpmLabelAusverkauft || '';
  var LABEL_AUSVERKAUFT_KURZ = root.dataset.kpmLabelAusverkauftKurz || '';

  // Kein eigener Geldformatierer hier. Alle Beträge kommen fertig
  // formatiert aus Liquid, damit Währung und Format eine Quelle haben.
  // Innerhalb des Kaufblocks.
  function setText(sel, value) {
    var el = root.querySelector(sel);
    if (el && value != null) el.textContent = value;
  }

  /* Dokumentweit. Seit der Aufteilung in einzelne Sektionen liegen die
   * Spec-Zeilen in kpm-product-specs, also AUSSERHALB von
   * [data-kpm-product]. root.querySelector findet sie nie. Fehlt die
   * Sektion, greift auch das hier ins Leere, was gewollt ist. */
  function setDocText(sel, value) {
    var el = document.querySelector(sel);
    if (el && value != null) el.textContent = value;
  }

  function apply(btn, pushUrl) {
    var d = btn.dataset;

    // Alle Höhen-Buttons synchron halten, auch den Satz in der Sticky-Leiste.
    root.querySelectorAll('[data-kpm-height]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.variantId === d.variantId ? 'true' : 'false');
    });

    var input = root.querySelector('[data-kpm-variant-input]');
    if (input) input.value = d.variantId;

    setText('[data-kpm-price]', d.priceMoney);
    setText('[data-kpm-sticky-price]', d.priceMoney);
    setText('[data-kpm-title]', d.title);
    /* Ohne Hoehe am Metafeld bleibt das Feld leer statt " cm" zu schreiben. */
    var cmLabel = d.cm ? d.cm + ' cm' : '';
    setText('[data-kpm-badge]', cmLabel);
    setText('[data-kpm-sticky-cm]', cmLabel);
    setText('[data-kpm-leadtime]', d.shipLead);

    // Versandblock. Kopf, Farbe und Fließtext stammen aus Liquid.
    var block = root.querySelector('[data-kpm-shipblock]');
    if (block) {
      var head = block.querySelector('.kpm-shipblock__head');
      var body = block.querySelector('.kpm-shipblock__body');
      if (head) {
        head.textContent = d.shipHead;
        head.style.color = d.shipHeadColor;
      }
      if (body) body.textContent = d.shipBody;
    }

    /* Spec-Zeilen der Materialtabelle. Sie liegen in einer eigenen Sektion
     * ausserhalb des Kaufblocks, deshalb setDocText und nicht setText. */
    setDocText('[data-kpm-spec-versand]', d.shipSpec);
    setDocText('[data-kpm-spec-hoehe]', d.cm);

    /* Galerie folgt der gewaehlten Ausfuehrung. Eine 210er Bambus sieht
     * anders aus als eine 123er, und wer die Hoehe wechselt, will das sehen.
     * Ohne data-img bleibt das Bild stehen, statt auf leer zu springen. */
    if (d.img) {
      var mainImg = document.querySelector('[data-kpm-main-img]');
      if (mainImg) {
        mainImg.src = d.img;
        mainImg.srcset = d.imgSrcset || '';
        if (d.imgAlt) mainImg.alt = d.imgAlt;
      }

      /* Thumbnail-Markierung mitziehen, sonst zeigt die Leiste weiter auf
       * das Bild der vorherigen Hoehe. Verglichen wird die 900er-Variante,
       * dieselbe Breite nutzt auch data-full. */
      document.querySelectorAll('[data-kpm-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.full === d.img ? 'true' : 'false');
      });
    }

    /* Kaufzustand. Ein Höhenwechsel kann von einer nicht lieferbaren auf
     * eine lieferbare Variante führen, dann muss der Kauf wieder offen sein. */
    var available = d.available === 'true';
    [root.querySelector('[data-kpm-cta]'), root.querySelector('[data-kpm-sticky-cta]')].forEach(
      function (cta) {
        if (!cta) return;
        cta.disabled = !available;
        cta.classList.toggle('kpm-btn--cta', available);
        cta.classList.toggle('kpm-btn--sold-out', !available);
      }
    );

    setText(
      '[data-kpm-cta-label]',
      available ? LABEL_CTA + ' · ' + d.priceMoney : LABEL_AUSVERKAUFT
    );
    setText('[data-kpm-sticky-cta]', available ? LABEL_CTA : LABEL_AUSVERKAUFT_KURZ);

    // Größenanker neu zeichnen.
    if (window.kpmDrawScale) window.kpmDrawScale(parseInt(d.cm, 10));

    if (pushUrl && d.cm) {
      var url = new URL(window.location.href);
      url.searchParams.set(PARAM, d.cm);
      history.replaceState({}, '', url);

      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute('href', url.toString());
    }
  }

  buttons.forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener('click', function () {
      apply(btn, true);
    });
  });

  /* Beim Laden aus der URL vorwählen. Beide Richtungen, nicht nur schreiben.
   * Ein Shopping-Klick auf "Olivenbaum 150 cm, 113,95 EUR" muss auf einer
   * Seite landen, die 113,95 EUR zeigt. Preisabweichung zwischen Feed und
   * Landingpage ist der häufigste Merchant-Center-Sperrgrund. */
  var wanted = new URLSearchParams(window.location.search).get(PARAM);
  if (wanted) {
    var match = null;
    buttons.forEach(function (b) {
      if (!match && b.dataset.cm === wanted && !b.disabled) match = b;
    });
    if (match) apply(match, false);
  }
})();
